import * as types from '../actionTypes/user'

export function getUser(user) {
  return {
    type: types.GET_USER,
    user
  }
}

export function getUsers(users) {
  return {
    type: types.GET_USERS,
    users
  }
}

export function updateUser(user) {
  return {
    type: types.UPDATE_USER,
    user
  }
}

export function addUser(user) {
  return {
    type: types.ADD_USER,
    user
  }
}

export function clearUser() {
  return {
    type: types.CLEAR_USER
  }
}


// WEBPACK FOOTER //
// ./src/actions/user.js